/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amarantos API
 * REST API for the Amarantos construction and infrastructure management platform. Supports both the Panel (web) and App (mobile) clients.
 *
 * OpenAPI spec version: 1.0.0
 */

export type NetworkType = typeof NetworkType[keyof typeof NetworkType];


export const NetworkType = {
  sanitary: 'sanitary',
  storm: 'storm',
  water: 'water',
} as const;
